<template>
  <div class="app-page">
    <Header ref="header">
      <template #header-slot>
        <BreadcrumbNavigation />
      </template>
      <template #page-slot>
        <BreadcrumbSelectProjectAndDataset />
      </template>
    </Header>
    <div class="main-page-div">
      <main class="main-display-area">
        <ReviewsTab />
      </main>
    </div>
  </div>
  <TasksModal />
</template>

<script setup>
import { useRoute } from 'vue-router';
import { decodeID } from '@/assets/js/utils.js';
import { onMounted, ref } from 'vue';
import Header from '@/components/Header.vue';
import ReviewsTab from '@/components/ReviewsPage/ReviewsTab.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import TasksModal from '@/components/TasksStatusComponent/TasksModalV2.vue';
import BreadcrumbSelectProjectAndDataset from '@/components/BreadcrumbSelectProjectAndDataset.vue';

const route = useRoute();
const projectId = ref(null);

onMounted(() => {
  // Extract and decode project ID from URL (e.g., /p-64/taskboard → 100)
  projectId.value = decodeID(route.params.projectId, 'p') || parseInt(route.params.projectId);
});
</script>

